import { TThunkAction } from '../../types/redux';
import {
  fetchPublicMyHomeV1GetThinClientInfo,
  TPublicMyHomeV1GetThinClientInfoResponse
} from '../../repositories/price-estimator/my-home/v1/get-thin-client-info';

import { BadRequestError } from '@cian/valuation-utils-component';
import { selectStatusList } from '../../selectors/status';
import { toggleStatusModal, setStatusList, toggleStatusLoad } from './actions';
import {
  ECode,
  IMyHomeStatusInfoSchema,
} from '../../repositories/price-estimator/entities/thin_client_info/MyHomeStatusInfoSchema';
import { EStatusLoad } from '../../types/redux/status';

export function statusListLoad(): TThunkAction<Promise<void>> {
  return async (dispatch, getState, context) => {
    const { httpApi, logger } = context;

    const state = getState();
    const statusList = selectStatusList(state);

    dispatch(toggleStatusModal(true));

    /**
     * Если данные уже есть, не запрашиваем их по новой
     */
    if (statusList.length > 0) {
      return;
    }

    dispatch(toggleStatusLoad(EStatusLoad.loading));

    try {
      const resp = (await fetchPublicMyHomeV1GetThinClientInfo({
        httpApi,
      })) as TPublicMyHomeV1GetThinClientInfoResponse;

      if (resp.statusCode !== 200) {
        throw new BadRequestError({
          message: resp.response.message as string,
          domain: 'statusLoad.ts',
          details: {
            errors: JSON.stringify(resp.response.errors),
          },
        });
      }

      const result = resp.response.myHomeStatus?.filter(status => status.code !== ECode.NotSelected) || [];

      dispatch(toggleStatusLoad(EStatusLoad.succeed));
      dispatch(setStatusList(result as IMyHomeStatusInfoSchema[]));
    } catch (e) {
      dispatch(toggleStatusLoad(EStatusLoad.failed));
      if (!(e instanceof BadRequestError)) {
        logger.error('Ошибка загрузки списка статусов', {
          message: e.message,
          domain: 'statusLoad.ts',
          details: e,
        });
      } else {
        logger.debug('Ошибка загрузки списка статусов', {
          message: e.message,
          domain: e.domain,
        });
      }

      dispatch(setStatusList([]));
    }
  };
}
